export const cxxJasTranslations = {
  CXX_JAS_TITLE: 'Tranzer JAS abonnement',
  CXX_JAS_SUBTITLE: 'Hoe werkt het JAS abonnement?',
};
